import { render, staticRenderFns } from "./PriorityZone.vue?vue&type=template&id=77531746&"
import script from "./PriorityZone.vue?vue&type=script&lang=js&"
export * from "./PriorityZone.vue?vue&type=script&lang=js&"
import style0 from "./PriorityZone.vue?vue&type=style&index=0&id=77531746&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports